import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    FirstName: {
      validations: []
    },
    LastName: {
      validations: []
    },
    email: {
      validations: [
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
    },
    telNumber: {
      validations: [
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' }
      ]
    },
    PartyName: {
      validations: []
    },
    theme: {
      validations: []
    },
    eventDate: {
      validations: [
        { type: 'dateinfuture', message: 'Event date must be in the future' }
      ]
    },
    starttime: {
      validations: []
    },
    endtime: {
      validations: []
    },
    plannedguestcount: {
      validations: [
        {type: 'regex', pattern: '^[0-9]*$', message: 'Please provide a guest count in numbers only.'},
      ]
    },
    notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name:',
            mapping: 'FirstName'
      },
      {
            type: 'text',
            size: 'Medium',
            label: 'Last Name:',
            mapping: 'LastName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email Address:',
            mapping: 'email'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone Number:',
            mapping: 'telNumber'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Event Name:',
            mapping: 'PartyName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Type of Event:',
            mapping: 'theme'
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Event Date:',
            mapping: 'eventDate'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Event Start Time:',
            options: [
              { label: '6:00 AM'  , value: '06:00:00'},
              { label: '6:30 AM'  , value: '06:30:00'},
              { label: '7:00 AM'  , value: '07:00:00'},
              { label: '7:30 AM'  , value: '07:30:00'},
              { label: '8:00 AM'  , value: '08:00:00'},
              { label: '8:30 AM'  , value: '08:30:00'},
              { label: '9:00 AM'  , value: '09:00:00'},
              { label: '9:30 AM'  , value: '09:30:00'},
              { label: '10:00 AM' , value: '10:00:00'},
              { label: '10:30 AM' , value: '10:30:00'},
              { label: '11:00 AM' , value: '11:00:00'},
              { label: '11:30 AM' , value: '11:30:00'},
              { label: '12:00 PM' , value: '12:00:00'},
              { label: '12:30 PM' , value: '12:30:00'},
              { label: '1:00 PM'  , value: '13:00:00'},
              { label: '1:30 PM'  , value: '13:30:00'},
              { label: '2:00 PM'  , value: '14:00:00'},
              { label: '2:30 PM'  , value: '14:30:00'},
              { label: '3:00 PM'  , value: '15:00:00'},
              { label: '3:30 PM'  , value: '15:30:00'},
              { label: '4:00 PM'  , value: '16:00:00'},
              { label: '4:30 PM'  , value: '16:30:00'},
              { label: '5:00 PM'  , value: '17:00:00'},
              { label: '5:30 PM'  , value: '17:30:00'},
              { label: '6:00 PM'  , value: '18:00:00'},
              { label: '6:30 PM'  , value: '18:30:00'},
              { label: '7:00 PM'  , value: '19:00:00'},
              { label: '7:30 PM'  , value: '19:30:00'},
              { label: '8:00 PM'  , value: '20:00:00'},
              { label: '8:30 PM'  , value: '20:30:00'},
              { label: '9:00 PM'  , value: '21:00:00'},
              { label: '9:30 PM'  , value: '21:30:00'},
              { label: '10:00 PM' , value: '22:00:00'},
              { label: '10:30 PM' , value: '22:30:00'},
              { label: '11:00 PM', value: '23:00:00' },
              { label: '11:30 PM', value: '23:30:00' },
              { label: '12:00 AM', value: '00:00:00' },
              { label: '12:30 AM', value: '00:30:00' },
              { label: '1:00 AM', value: '01:00:00' },
              { label: '1:30 AM', value: '01:30:00' },
              { label: '2:00 AM', value: '02:00:00' },
            ],
            mapping: 'starttime'
          }
        ]
      },
      {
        fields: [
          {
        type: 'multiple-choice',
        size: 'Medium',
        label: 'Event End Time:',
        options: [
          { label: '6:00 AM'  , value: '06:00:00'},
          { label: '6:30 AM'  , value: '06:30:00'},
          { label: '7:00 AM'  , value: '07:00:00'},
          { label: '7:30 AM'  , value: '07:30:00'},
          { label: '8:00 AM'  , value: '08:00:00'},
          { label: '8:30 AM'  , value: '08:30:00'},
          { label: '9:00 AM'  , value: '09:00:00'},
          { label: '9:30 AM'  , value: '09:30:00'},
          { label: '10:00 AM' , value: '10:00:00'},
          { label: '10:30 AM' , value: '10:30:00'},
          { label: '11:00 AM' , value: '11:00:00'},
          { label: '11:30 AM' , value: '11:30:00'},
          { label: '12:00 PM' , value: '12:00:00'},
          { label: '12:30 PM' , value: '12:30:00'},
          { label: '1:00 PM'  , value: '13:00:00'},
          { label: '1:30 PM'  , value: '13:30:00'},
          { label: '2:00 PM'  , value: '14:00:00'},
          { label: '2:30 PM'  , value: '14:30:00'},
          { label: '3:00 PM'  , value: '15:00:00'},
          { label: '3:30 PM'  , value: '15:30:00'},
          { label: '4:00 PM'  , value: '16:00:00'},
          { label: '4:30 PM'  , value: '16:30:00'},
          { label: '5:00 PM'  , value: '17:00:00'},
          { label: '5:30 PM'  , value: '17:30:00'},
          { label: '6:00 PM'  , value: '18:00:00'},
          { label: '6:30 PM'  , value: '18:30:00'},
          { label: '7:00 PM'  , value: '19:00:00'},
          { label: '7:30 PM'  , value: '19:30:00'},
          { label: '8:00 PM'  , value: '20:00:00'},
          { label: '8:30 PM'  , value: '20:30:00'},
          { label: '9:00 PM'  , value: '21:00:00'},
          { label: '9:30 PM'  , value: '21:30:00'},
          { label: '10:00 PM' , value: '22:00:00'},
          { label: '10:30 PM' , value: '22:30:00'},
          { label: '11:00 PM', value: '23:00:00' },
          { label: '11:30 PM', value: '23:30:00' },
          { label: '12:00 AM', value: '00:00:00' },
          { label: '12:30 AM', value: '00:30:00' },
          { label: '1:00 AM', value: '01:00:00' },
          { label: '1:30 AM', value: '01:30:00' },
          { label: '2:00 AM', value: '02:00:00' },
        ],
        mapping: 'endtime'
      }
    ]
  },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Estimated Number of Guests:',
            mapping: 'plannedguestcount'
          }
        ]
      },

      {
        fields: [
          {
            type: 'text-area',
            size: 'XLarge',
            label: 'Any Additional Details About Your Event?',
            mapping: 'notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'SEND'
          }
        ]
      }
    ]
  },
  info: {
    title: 'National Corvette Museum Contact Us Form',
    formId: '1908',
    clientKey: '8D9700E5-748E-415F-9BD0-9460F9411649',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will be in contact very soon.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
